import { sub } from 'framer-motion/client'
import { CheckCircle2 } from 'lucide-react'

export const Workflow = ({featuresList, side, image, title, subtitle, imageSize}) => {
    return (
        <div className="mt-20 border-t border-neutral-800">
            <h2 className="text-3xl sm:text-5xl lg:text-6xl text-center mt-6 tracking-wide">
                {title}
                <span className="bg-gradient-to-r from-purple-500 to-purple-800 text-transparent bg-clip-text">
                    {' '}
                    {subtitle}
                </span>
            </h2>
            {side ? 
                (<div className="flex flex-wrap justify-center mt-10">
                    <div className={`ml-6 p-2 w-full lg:w-[${imageSize || 70}%]`}>
                        <img referrerPolicy="no-referrer" src={image} alt="imagem" className='rounded-3xl shadow-2xl' />
                    </div>
                    <div className="pt-12 w-full lg:w-[20%]">
                        {featuresList.map((item, index) => (
                            <div key={index} className="flex mb-12">
                                <div className="text-purple-500 to-purple-800 mx-6 bg-neutral-900 h-10 w-10 p-2 justify-center items-center rounded-full">
                                    <CheckCircle2 />
                                </div>
                                <div>
                                    <h5 className="mt-1 mb-2 text-xl">{item.title}</h5>
                                    <p className="text-md text-neutral-500">{item.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>) :
                        
                            (<div className="flex flex-wrap justify-center mt-10">
                                <div className="pt-12 w-full lg:w-[25%]">
                                    {featuresList.map((item, index) => (
                                        <div key={index} className="flex mb-12">
                                            <div className="text-purple-500 to-purple-800 mx-6 bg-neutral-900 h-10 w-10 p-2 justify-center items-center rounded-full">
                                                <CheckCircle2 />
                                            </div>
                                            <div>
                                                <h5 className="mt-1 mb-2 text-xl">{item.title}</h5>
                                                <p className="text-md text-neutral-500">{item.description}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className={`ml-6 p-2 w-full lg:w-[${imageSize || 70}%]`}>
                                    <img referrerPolicy="no-referrer" src={image} alt="imagem" className='rounded-3xl shadow-2xl' />
                                </div>
                            </div>
                        )}
        </div>
    )
}

export default Workflow
